import type { ImgHTMLAttributes } from "react";

import { useImageFallback } from "./useImageFallback.js";

export type OptionalImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "onError"> & {
  src: string | null | undefined;
};

/**
 * An image the layout can do without (a glow behind art, a banner's photo, a notification's
 * picture): drawn while it loads and once it has, and nothing at all when its source is missing
 * or fails, never the browser's broken-image icon or its alt text spilling into the layout.
 */
export function OptionalImage({ src, alt = "", ...props }: OptionalImageProps) {
  const { failed, onError } = useImageFallback(src);
  if (failed || !src) return null;
  return <img {...props} src={src} alt={alt} onError={onError} />;
}
